import { defineMessages } from "@ai360/core/intl";

export const messages = defineMessages({
    addLocation: { id: "setup.definedLegend.addLocation", defaultMessage: "Add Location" },
    city: { id: "setup.definedLegend.city", defaultMessage: "City" },
    name: { id: "setup.definedLegend.name", defaultMessage: "Name" },
    state: { id: "setup.definedLegend.state", defaultMessage: "State" },
    deleteConfirmationTitle: {
        id: "setup.definedLegend.deleteConfirmationTitle",
        defaultMessage: "Delete Confirmation",
    },
    deleteConfirmationMessage: {
        id: "setup.definedLegend.deleteConfirmation",
        defaultMessage: "Are you sure you want to delete the selected Owner Defined Legend?",
    },
    layerType: {
        id: "setup.definedLegend.layerType",
        defaultMessage: "Layer Type",
    },
    location: {
        id: "setup.definedLegend.location",
        defaultMessage: "Location",
    },
    attributeName: {
        id: "setup.definedLegend.attributeName",
        defaultMessage: "Attribute",
    },
    crop: {
        id: "setup.definedLegend.crop",
        defaultMessage: "Crop",
    },
    cropPurposeName: {
        id: "setup.definedLegend.cropPurposeName",
        defaultMessage: "Crop Purpose",
    },
    canDelete: {
        id: "setup.definedLegend.canDelete",
        defaultMessage: "Can Delete",
    },
    colorRamp: {
        id: "setup.definedLegend.colorRamp",
        defaultMessage: "Color Ramp",
    },
    locationAffiliations: {
        id: "setup.definedLegend.locationAffiliations",
        defaultMessage: "Location Affiliations",
    },
    numberOfClasses: {
        id: "setup.definedLegend.numberOfClasses",
        defaultMessage: "# of Classes",
    },
    surfaceDefault: {
        id: "setup.definedLegend.surfaceDefault",
        defaultMessage: "Add Surface Default",
    },
    displayTypeName: {
        id: "setup.definedLegend.displayTypeName",
        defaultMessage: "Display Type",
    },
    productName: {
        id: "setup.definedLegend.productName",
        defaultMessage: "Product",
    },
    unknownProduct: {
        id: "setup.definedLegend.unknownProduct",
        defaultMessage: "Saved Product",
    },
    classBreakValidationError: {
        id: "setup.definedLegend.classBreakValidationError",
        defaultMessage:
            "Class breaks must be contiguous and ascending and all editable bounds must be non-zero.",
    },
    classBreakValidationErrorTitle: {
        id: "setup.definedLegend.classBreakValidationErrorTitle",
        defaultMessage: "Validation Error",
    },
});
